import { Select } from '@mui/material';
import { styled } from '@mui/styles';

const SearchBarSelect = styled(Select)(() => ({
	color: '#707070 !important',
	fontFamily: 'Montserrat !important',
	fontSize: '14px !important',
	height: 18,
	'&:after': {
		borderBottom: 'none !important',
	},
	'&:hover:not(.Mui-disabled):before': {
		borderBottom: 'none !important',
	},
	'&:before': {
		borderBottom: 'none !important',
	},
	'& .MuiInput-input': {
		padding: '0 !important',
	},
	'& .MuiSelect-select': {
		fontSize: 14,
		fontWeight: 600,
		paddingRight: 24,
		width: 172,
		'&:focus': {
			backgroundColor: 'transparent !important',
		},
	},
}));

export default SearchBarSelect;
